import { useEffect, useState } from "react";
import { Event, emptyEvent } from "../../../interfaces/event";
import { Media } from "../../../interfaces/media";
import { getEventSingle } from "../../../services/event";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";
import { t } from "i18next";

export function EventView() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(false);
    const [event, setEvent] = useState<Event>(emptyEvent);

    useEffect(() => {
        getEventSingle(params.id)
            .then(response => {
                setEvent(response.data);
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <div className="event-view-container">
            <div className="inner">
                { !loaded &&
                    <LoadingSpinner />
                }
                { loaded &&
                    <>
                        <h1>{ event.name }</h1>
                        <div className="content-data content-box event-view-card">
                            <dl className="event-meta">
                                <dt className="meta-label">
                                    <i className="bi bi-calendar-event"></i>{ t('Date') }
                                </dt>
                                <dd className="meta-value">{ event.date_description }</dd>

                                { event.venue_name &&
                                    <>
                                        <dt className="meta-label">
                                            <i className="bi bi-geo-alt"></i>{ t('venue_name') }
                                        </dt>
                                        <dd className="meta-value">{ event.venue_name }</dd>
                                    </>
                                }

                                { event.venue_link &&
                                    <>
                                        <dt className="meta-label">
                                            <i className="bi bi-link-45deg"></i>{ t('venue_link') }
                                        </dt>
                                        <dd className="meta-value">
                                            <a href={ event.venue_link } target="_blank" rel="noopener noreferrer">
                                                { event.venue_link }
                                                <i className="bi bi-box-arrow-up-right ms-1"></i>
                                            </a>
                                        </dd>
                                    </>
                                }
                            </dl>

                            { event.description &&
                                <div className="event-description">
                                    { event.description }
                                </div>
                            }

                            { event.documents && event.documents.length > 0 &&
                                <div className="event-documents-section">
                                    <h3>
                                        <i className="bi bi-paperclip"></i>{ t('Documents') }
                                    </h3>
                                    <ul className="event-documents">
                                        { event.documents.map((m: Media) => (
                                            <li key={ m.id }>
                                                <a href={ m.url } target="_blank" rel="noopener noreferrer" title={ m.name }>
                                                    <i className="bi bi-file-earmark-pdf"></i>
                                                    <span>{ m.name }</span>
                                                    <i className="bi bi-box-arrow-up-right ms-auto"></i>
                                                </a>
                                            </li>
                                        )) }
                                    </ul>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </div>
    );
}
